/* Simply Bearings UK â€” shared grab-to-scroll behavior for opted-in sliders.
   Mouse only: touch and pen keep their native scrolling behavior. */
(() => {
  const ROOT_FLAG = 'data-ax-slider-drag-ready';
  const SLIDER_SELECTOR = '[data-ax-slider-drag]';
  const DRAG_THRESHOLD = 5;

  if (document.documentElement.hasAttribute(ROOT_FLAG)) return;
  document.documentElement.setAttribute(ROOT_FLAG, 'true');

  const initDrag = (slider) => {
    if (slider.dataset.axSliderDragInitialized) return;
    slider.dataset.axSliderDragInitialized = 'true';

    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let dragged = false;

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = slider.scrollLeft;
      dragged = false;
    });

    slider.addEventListener('pointermove', (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if ((event.buttons & 1) === 0) {
        pointerId = null;
        slider.classList.remove('ax-slider-dragging');
        return;
      }

      const delta = event.clientX - startX;
      if (!dragged) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragged = true;
        try {
          slider.setPointerCapture(pointerId);
        } catch {
          // Pointer capture is optional; scrolling remains functional without it.
        }
        slider.classList.add('ax-slider-dragging');
      }

      slider.scrollLeft = startScroll - delta;
    });

    const endDrag = (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      pointerId = null;
      slider.classList.remove('ax-slider-dragging');
      if (event.type === 'pointercancel') dragged = false;
    };

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener(
      'click',
      (event) => {
        if (!dragged) return;
        dragged = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
    slider.addEventListener('dragstart', (event) => event.preventDefault());
  };

  const initRoot = (root) => {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(initDrag);
  };

  initRoot(document);
  document.addEventListener('shopify:section:load', (event) => initRoot(event.target));
})();
